import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Logger } from '@saviynt/common';

import { useGetSodViolationsReportPreviewMutation } from '../data-layer/violationsReportApi';
import {
  type GetSodViolationsReportPreviewRequest,
  type SodViolationReportData,
} from '../data-layer/violationsReportTypes';
import { violationsReportActions } from '../data-store/violationsReportSlice';

const useSodViolationsReportPreview = () => {
  const dispatch = useDispatch();
  const [fetchSodViolationsReportPreview] =
    useGetSodViolationsReportPreviewMutation();

  const getSodViolationsReportPreview = useCallback(
    async (
      payload: GetSodViolationsReportPreviewRequest,
      reportType: string
    ) => {
      try {
        dispatch(violationsReportActions.setIsLoading(true));
        const response = (await fetchSodViolationsReportPreview({
          payload,
          reportType,
        }).unwrap()) as SodViolationReportData[];

        dispatch(violationsReportActions.setSodViolationsReportData(response));
        dispatch(violationsReportActions.setIsLoading(false));

        return true;
      } catch (error) {
        Logger.log('Error fetching SOD violations report preview:', error);
        dispatch(violationsReportActions.setIsLoading(false));

        return false;
      }
    },
    [fetchSodViolationsReportPreview, dispatch]
  );

  return { getSodViolationsReportPreview };
};

// eslint-disable-next-line import/prefer-default-export
export { useSodViolationsReportPreview };
